app.controller(
    'LoginController', ['$scope', '$rootScope', '$location', 'AuthenticationService', 'FlashService', 'UserService', '$stateParams', '$state', '$translate', LoginController]
);

function LoginController($scope, $rootScope, $location, AuthenticationService, FlashService, UserService, $stateParams, $state, $translate) {
    var vm = this;

    vm.login = login;
    vm.LoginToken = LoginToken;
    vm.Email = "";
    vm.Password = "";
    vm.userToLog = {};
    vm.RememberMe = true;
    $rootScope.expiryDurationInSecond = 36000;

    vm.ShowWrongPasswordMessage = false;

    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }
    $translate.use($scope.CurrentLang);

    (function initController() {
        // reset login status
        AuthenticationService.ClearCredentials();
    })();

    function login() {
        vm.dataLoading = true;
        AuthenticationService.Login(vm.Email, vm.Password, vm.RememberMe,
            function (response) {
                if (response.status == 200) {
                    //load authourised zone liste
                    $rootScope.LangForInterface = response.data.LangForInterface;
                    UserService.GetZoneMenuItemList()
                        .then(function (data) {
                            $rootScope.ZoneMenuItemList = data;
                            $rootScope.CurrentZone = $rootScope.ZoneMenuItemList[0];
                            $rootScope.DefaultGlobalZoneId = $rootScope.CurrentZone.ZoneId;
                            if ($rootScope.returnUrlAfterLogin && !$rootScope.returnUrlAfterLogin.includes('login')) {
                                window.location.href = $rootScope.returnUrlAfterLogin;                                
                            }
                            else {

                                //$state.go('app.list.place', { z: $rootScope.DefaultGlobalZoneId, lang: $rootScope.LangForInterface });
                                $state.go('app.home');
                            }
                        });
                    vm.ShowWrongPasswordMessage = false;
                } else {
                    FlashService.Error(response.message);
                    vm.dataLoading = false;
                    vm.ShowWrongPasswordMessage = true;
                }
            });
    };

    function LoginToken() {
        alert("LoginToken");
        vm.dataLoading = true;
        AuthenticationService.LoginToken(vm.Email, vm.Password, function (response) {
            console.log(response);
            if (response.success) {
                console.log("AuthenticationService.Login sucess Email: " + vm.Email);
                console.log("Password: " + vm.Password);
                AuthenticationService.SetCredentials(vm.Email, vm.Password);
                $location.path('/');
            } else {
                FlashService.Error(response.message);
                vm.dataLoading = false;
            }
        });
    };

    vm.Logout = function () {
        AuthenticationService.Logout();
    };

    $rootScope.hostname = $location.host();
}

